// Derived at build time from the env var so classification stays correct
// if the Lambda Function URL ever changes.
const ML35_LAMBDA_HOST = (() => {
  try { return new URL(process.env.REACT_APP_DIRECT_PROXY_URL).hostname }
  catch { return '' }
})()
const APPSYNC_HOST = 'appsync-api.eu-west-2.amazonaws.com'

export const classifyCspBlockedURI = (blockedURI) => {
  if (!blockedURI || blockedURI === 'inline' || blockedURI === 'eval') return 'OTHER'
  if (blockedURI.includes('datadoghq')) return 'DATADOG'
  if (blockedURI.includes(ML35_LAMBDA_HOST)) return 'ML35_LAMBDA'
  if (blockedURI.includes('shift4.com')) return 'SHIFT4'
  if (blockedURI.includes(APPSYNC_HOST)) return 'APPSYNC'
  return 'OTHER'
}
